<div>
  @if (duplicateIndicators.length === 0) {
    <div class="text-center p-5">
      <i class="pi pi-check-circle text-5xl text-green-500 mb-3"></i>
      <h3 class="text-xl">Keine Probleme gefunden</h3>
      <p class="text-color-secondary">
        Alle Indikatoren sind eindeutig. Jeder Schlüssel ist nur einmal im
        System vorhanden.
      </p>
    </div>
  } @else {
    <!-- Filter and Action Bar -->
    <div
      class="flex justify-content-between align-items-center mb-4 gap-3 py-1">
      <div class="flex flex-column gap-2">
        <label class="text-sm font-semibold">Filter</label>
        <p-selectButton
          [options]="filterOptions"
          [(ngModel)]="filterState"
          optionLabel="label"
          optionValue="value"></p-selectButton>
      </div>

      <div class="flex flex-column gap-2 align-items-end">
        <div class="flex align-items-center gap-2">
          <p-checkbox
            [(ngModel)]="canSafelyDelete"
            [binary]="true"
            inputId="safe-delete"></p-checkbox>
          <label for="safe-delete" class="text-sm cursor-pointer"
            >Kann sicher gelöscht werden</label
          >
        </div>
        <p-button
          [rounded]="true"
          label="Doppelte Indikatoren ohne Daten löschen"
          icon="pi pi-trash"
          severity="danger"
          [disabled]="!canSafelyDelete()"
          (onClick)="deleteIndicatorsWithoutData()"></p-button>
      </div>
    </div>

    <!-- Summary -->
    <div class="mb-3">
      <p class="text-color-secondary">
        Es wurden <strong>{{ duplicateIndicators.length }}</strong> Indikatoren
        mit doppeltem Schlüssel gefunden.
        @if (filteredIndicators().length !== duplicateIndicators.length) {
          <span>
            ({{ filteredIndicators().length }} nach Filter angezeigt)
          </span>
        }
      </p>
    </div>

    <!-- Table -->
    <p-table
      [value]="filteredIndicators()"
      [columns]="cols"
      [paginator]="true"
      [rows]="10"
      [rowsPerPageOptions]="[10, 25, 50]"
      [tableStyle]="{ 'min-width': '50rem' }"
      styleClass="p-datatable-sm">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns">{{ col.header }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item let-columns="columns">
        <tr>
          <td>
            <i
              class="fas"
              [class.fa-ruler-combined]="item.indicator.isSet"
              [class.fa-ruler]="item.indicator.parent"
              [class.fa-ruler-horizontal]="
                !item.indicator.isSet && !item.indicator.parent
              "></i>
          </td>
          <td>
            <app-full-indicator-name
              [indicator]="item.indicator"
              mode="quiet" />
          </td>
          <td>
            <p-chip [label]="item.key" styleClass="text-xs"></p-chip>
          </td>
          <td class="text-right">
            <p-tag
              [style]="{ 'min-width': '1.625rem' }"
              [value]="item.dataCount.toString()"
              [severity]="item.dataCount === 0 ? 'danger' : 'success'"
              [rounded]="true"></p-tag>
          </td>
          <td class="text-right">
            <p-tag
              [style]="{ 'min-width': '1.625rem' }"
              [value]="item.duplicateCount.toString()"
              severity="warning"
              [rounded]="true"></p-tag>
          </td>
        </tr>
      </ng-template>
    </p-table>
  }
</div>
